import React from 'react'
import Manager from '../../public/components/Manager'
import PurchaseDiv from './PurchaseDiv'
Ext.require('Ext.Toast')

const disableBatch = ({ state: { selected = null } }) => !selected || !selected.length
const config = () => {
    const handelGeneratePurchaseOrder = ({ showDetail, refreshPage, state: { selected }, props: { dispatch } }) => {
        const currency = selected && Array.from(new Set(selected.map(o => o.data.原币别))) || []
        const list = selected && selected.map(o => o.data.id) || []
        if (currency.length > 1) {
            Ext.toast('币别必须相同')
            return
        }
        Tyan.doPostEvent({
            event: 'CreatePurchase',
            data: { list },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    showDetail(props => <PurchaseDiv {...props} id={id} onSave={refreshPage} />)
                }
            }
        })
    }
    return {
        multiSelect: true,
        buttons: [
            { text: '生成采购单', handler: that => handelGeneratePurchaseOrder(that), disabled: disableBatch }
        ],
        columns: [
            { _text: '请购单号', field: 'ReqPurchase.Number', minWidth: 150, search: true, flex: 1 },
            { _text: '物料代码', field: 'MaterialNumber', minWidth: 150, search: true, flex: 1 },
            { _text: '物料名称', field: 'MaterialName', minWidth: 150, flex: 1 },
            { _text: '规格型号', field: 'SpecificationModel', minWidth: 150, flex: 1 },
            { _text: '单位', field: 'Unit', minWidth: 80, flex: 1 },
            { _text: '供应商', field: 'Supplier', minWidth: 250, search: true, flex: 1 },
            { _number: '数量', field: 'Quantity', minWidth: 80, flex: 1 },
            { _float: '原币未税单价', field: 'OCNoTaxUnit', minWidth: 150, flex: 1, format: '0,000.0000', },
            { _text: '原币别', field: 'ReqPurchase.Currency', minWidth: 80, flex: 1 },
            { _number: '本币含税金额', field: 'LCTaxAmount', minWidth: 150, flex: 1 },
            { _date: '建议采购时间', field: 'PoposalPurchaseDate', minWidth: 150, flex: 1 },
            { _text: '用途', field: 'Purpose', minWidth: 150, flex: 1 },
            { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1 },
            { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            { _text: '申请部门', field: 'CreateDep', minWidth: 250, flex: 1 },
            { _text: '请购类别', field: 'RequisitionStatus', minWidth: 150, flex: 1 },
            { _text: '加急件', field: 'ReqPurchase.Urgent', minWidth: 150, flex: 1 },
            { _text: '采购类别', field: 'PurchaseStatus', minWidth: 150, flex: 1 },
            { _date: '要求送达日期', field: 'ArrivalDate', minWidth: 150, flex: 1 },
        ],
        onDoubleTap: ({ showDetail, refreshPage }, data) => {
        }
    }
}

export default props => <Manager {...props} config={config} />